import React, { useState, useEffect } from 'react';
import './HeroBanner.css';

// Import hero images
import heroOilsImg from '../assets/images/hero/hero-oils.jpg';
import heroSpicesImg from '../assets/images/hero/hero_2.jpg';
import heroMilletsImg from '../assets/images/hero/hero_03.jpg';
import heroEcoImg from '../assets/images/hero/hero_4.jpg';

const HeroBanner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Product-aligned banner images with relevant subtexts
  const slides = [
    {
      image: heroOilsImg,
      alt: 'Oils & Natural Extracts',
      subtext: 'Pure Oils & Natural Extracts'
    },
    {
      image: heroSpicesImg,
      alt: 'Spices & Powders',
      subtext: 'Authentic Spices & Powders'
    },
    {
      image: heroMilletsImg,
      alt: 'Millets & Grains',
      subtext: 'Nutritious Millets & Grains'
    },
    {
      image: heroEcoImg,
      alt: 'Fresh & Eco Products',
      subtext: 'Fresh Produce & Eco-Friendly Products'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 4000); // Change slide every 4 seconds

    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="hero-banner" id="home">
      <div className="hero-slider">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="hero-overlay"></div>
          </div>
        ))}
      </div>

      <div className="hero-content">
        <h1 className="hero-title">Premium Agro Products for Global Markets</h1>
        <p className="hero-subtitle">{slides[currentSlide].subtext}</p>
        <p className="hero-tagline">Quality | Sustainability | Trust</p>
      </div>

      <div className="hero-dots">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`hero-dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          ></button>
        ))}
      </div>
    </div>
  );
};

export default HeroBanner;
